import { Route, Routes } from 'react-router-dom';
import { NotFound, ExpenseType } from '@pages';
import { Protected } from '@components';

function RoutesExpenseType() {
  return (
    <Protected>
      <Routes>
        <Route index element={<ExpenseType />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}

export default RoutesExpenseType;
